export const FLOW_TO_TYPING_SPEED_CONFIG_MAP = {
  UCS_CHANGE_PIN: [
    { id: 'text-input-pin', min: 4 },
    { id: 'text-input-confirmPin', min: 4 },
  ],
  UCS_VIEW_PIN: [
    { id: 'text-input-cvv', min: 3 },
    { id: 'text-input-confirmCvv', min: 3 },
  ],
  UCS_ACTIVATE_CARD_ENTER_CVV: [{ id: 'text-input-cvvField', min: 3 }],
  UCS_SET_PIN: [
    { id: 'text-input-setPin', min: 4 },
    { id: 'text-input-confirmPin', min: 4 },
  ],
} as const

export type TypingSpeedFlowName = keyof typeof FLOW_TO_TYPING_SPEED_CONFIG_MAP

export const isTypingSpeedConfigRequired = (flowName: string = ''): boolean => {
  return Object.keys(FLOW_TO_TYPING_SPEED_CONFIG_MAP).includes(flowName)
}
